export default {
  loading: false,
  deviceToken: "abcdefghijkl",
  userProfile: {},
  languageList:[]
};
